import { render } from "./index.vue?vue&type=template&id=6d7aadd6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6d7aadd6&scoped=true&lang=css"

import exportComponent from "/usr/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7aadd6"]])

export default __exports__